import { humanizeString } from '../../../utils/stringMinipulation'
import isEmpty from 'lodash/isEmpty'
import flatten from 'lodash/flatten'

export const buildAllocationsDataProp = (allocationsDataset) => {
  const flattenedAllocations = flatten(allocationsDataset)
  const labels = isEmpty(flattenedAllocations) ? ['No assets'] : Object.keys(flattenedAllocations[0]).map(label => humanizeString(label))

  const datasets = isEmpty(flattenedAllocations)
    ? [emptyDataset([100], greyedOutColor)]
    : buildDatasets(allocationsDataset)

  return {
    datasets,
    labels
  }
}

const buildDatasets = (allocationsDataset) =>
  allocationsDataset.map((allocations, index) => {
    const averageAllocationValues = Object.values(allocations).map(value => value * 100)
    return isEmpty(allocations)
      ? emptyDataset([0, 0, 0, 0, 0, 0, 0, 0], backgroundColor)
      : {
        label: (index === 0 && allocationsDataset.length === 2) ? 'Scenario asset allocation' : 'Implemented plan asset allocation',
        data: averageAllocationValues,
        spacing: 1,
        backgroundColor
      }
  })

const emptyDataset = (data, backgroundColor) => ({
  label: 'No assets',
  data,
  backgroundColor
})

const backgroundColor = [
  '#BF616A',
  '#D08770',
  '#EBCB8B',
  '#A3BE8C',
  '#B48EAD',
  '#5E81AC',
  '#88C0D0',
  '#D8DEE9',
  '#4C566A'
]

const greyedOutColor = [
  '#D8DEE9'
]
